import React, { useContext, useEffect } from 'react'
import '../css/alert.css'
import ServiceContext from '../ServiceContext'

const defaultAlert = {
    ID: 1,
    message: '',
    ttl: 1000,
    visible: false
}

const Alert = () => {
    const serviceContext = useContext(ServiceContext)

    const deleteAlert=(ID)=>{
        serviceContext.set(draft => { draft.Alerts = draft.Alerts.filter(alert=>alert.ID!=ID) })
    }

    useEffect(() => {
        if (serviceContext.get.Alerts.length>0) {
            serviceContext.get.Alerts.forEach((ale, i)=>{
                if(!ale.visible){
                    serviceContext.set(draft => { draft.Alerts[i].visible = true })
                    setTimeout(() => {
                        serviceContext.set(draft => { draft.Alerts = draft.Alerts.filter(alert=>alert.ID!=ale.ID) })
                    }, ale.ttl)
                }
            })
        }
        //console.log('visibile', globalContext.get.Alert.visible, globalContext.get.Alert.show && !globalContext.get.Alert.visible)
    }, [serviceContext.get])


    return (
        <div className='global-alert-container'>
            {serviceContext.get.Alerts.filter(ale=>ale.visible).reverse().map(ale=>(
                <div key={ale.ID} className='global-alert' onClick={()=>deleteAlert(ale.ID)}>
                    <p className='nac-text global-alert-text' >
                        {ale.message}
                    </p>
                </div>
            ))}
        </div>
    )
}


export default Alert